<template>
    <header-mobile></header-mobile>
    <div id="body">
        <div class="row">
            <div class="col-12">
                <div class="card" style="min-height:200px;">
                    <div class="card-body" style="position:relative;padding-top:170px;">
                        <div id="home-card">
                            <h1 style="color:white;width:100%;font-size:2em">Hi, {{ name }}</h1>
                        </div>
                        <div id="total-invoice">
                            <div class="row">
                                <div class="col-6" style="border-right:1px solid rgba(0,0,0,.1)">
                                    <font-awesome-icon icon="fa-solid fa-wallet" class="icon-wallet" />
                                    &nbsp; <span style="font-size:1.5em;">Tagihan</span>
                                    <div class="nominal">
                                        <div v-if="loadingData == true">
                                            -
                                        </div>
                                        <div v-else>
                                            {{ total_tagihan }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <font-awesome-icon icon="fa-solid fa-circle-user" class="icon-user icon-red"
                                        v-if="suspend == false" />
                                    <font-awesome-icon icon="fa-solid fa-circle-user" class="icon-user icon-green" v-else />
                                    &nbsp; <span style="font-size:1.5em;">Status Kurir</span>
                                    <div class="nominal">
                                        <div v-if="loadingData == true">
                                            -
                                        </div>
                                        <div v-else>
                                            {{ status_courier }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="border-bottom:1px solid rgba(0,0,0,.1);padding-bottom:5px;margin-bottom:5px;">
                            <div class="row">
                                <div class="col-6">
                                    <font-awesome-icon icon="fa-solid fa-credit-card" class="icon-dollar" />&nbsp; <span
                                        style="font-size:1.5em;font-weight:bold;">Rekening</span><br>
                                    <p style="font-size:1.3em;font-weight:bold;margin-top:10px;">{{ virtual_account_no
                                    }}<br>
                                        {{ virtual_account_name }}
                                    </p>
                                </div>
                                <div class="col-6">
                                    <font-awesome-icon icon="fa-solid fa-truck" class="icon-truck" /> &nbsp; <span
                                        style="font-size:1.5em;font-weight:bold;">Handover</span><br>
                                    <p style="font-size:1.3em;font-weight:bold;margin-top:10px;">{{ handover }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <loading-mobile v-if="loadingData == true"></loading-mobile>
                        <div id="list-invoice" v-else-if="list_tagihan.length > 0">

                            <div class="row">
                                <div class="col-6">
                                    <font-awesome-icon icon="fa-solid fa-list-ul" class="icon-list" />&nbsp; <span
                                        style="font-size:1.5em;font-weight:bold;">list Tagihan Kurir</span>
                                </div>


                                <div class="col-6" style="text-align:end" @click="refreshTrigger">
                                    <button class="btn btn-success">
                                        <font-awesome-icon icon="fa-solid fa-refresh" />
                                        Refresh
                                    </button>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-row-dashed table-row-gray-300 gy-7">
                                    <thead>
                                        <tr class="fw-bolder fs-6 text-gray-800">
                                            <th>No</th>
                                            <th class="no-break">No. Manifest Kurir</th>
                                            <th>Tagihan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(strc, index) in list_tagihan" :key="strc.no_manifest">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ strc.no_manifest }}</td>
                                            <td>
                                                {{ rupiahs(strc.bill) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div id="not-found" class="text-center" v-else>
                            <img src="../assets/media/apps/not-found.png" alt="not-found-img" />
                            <div style="font-size:1.5em;">Tagihan Tidak Ditemukan</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <nav-bar></nav-bar>
</template>
<script>
import HeaderMobile from './HeaderMobile.vue'
import NavBar from './NavBar.vue'
import LoadingMobile from './LoadingMobile.vue'
import api from '../api'
import { toast } from 'vue3-toastify'

export default {
    name: 'MainPage',
    components: {
        HeaderMobile,
        NavBar,
        LoadingMobile
    },
    data() {
        return {
            list_tagihan: [],
            suspend: false,
            handover: 0,
            tagihan: 54687993,
            loadingData: false,
            name: localStorage.getItem('name'),
            virtual_account_no: localStorage.getItem('virtual_account_no'),
            virtual_account_name: localStorage.getItem('virtual_account_name'),
        }
    },
    methods: {
        refresh() {
            this.loadingData = true
            api.post("invoice_sapx", {
                params: {
                    "token": localStorage.getItem('token')
                }
            }).then((response) => {
                if (response.data.alert == 'success') {
                    this.list_tagihan = response.data.data.invoice
                    let sum = 0
                    for (let i = 0; i < response.data.data.invoice.length; i++) {
                        sum = sum + parseInt(response.data.data.invoice[i].bill)
                    }
                    this.tagihan = sum
                    this.suspend = response.data.data.status
                    this.handover = response.data.data.handover + " AWB"
                    this.loadingData = false
                } else if (response.data.alert == 'relog') {
                    localStorage.removeItem("token")
                    localStorage.removeItem("name")
                    this.$router.push("/")
                } else {
                    toast(response.data.msg, {
                        autoClose: 3000,
                        theme: "light",
                        type: "error",
                        pauseOnHover: false,
                        position: "top-right",
                        multiple: false
                    })
                    this.loadingData = false
                }
            }).catch(function () {
                // this.loadingData = false
                toast("Masalah Jaringan", {
                    autoClose: 3000,
                    theme: "light",
                    type: "error",
                    pauseOnHover: false,
                    position: "top-right",
                    multiple: false
                })
            })
        },
        rupiahs(number) {
            let number_string = number.toString(),
                split = number_string.split(','),
                sisa = split[0].length % 3,
                rupiah = split[0].substring(0, sisa),
                ribuan = split[0].substring(sisa).match(/\d{3}/gi),
                separator = ''


            if (ribuan) {
                separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.')
            }

            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah
            return (rupiah ? 'Rp. ' + rupiah : '')
        },
        refreshTrigger() {
            this.refresh();
        }
    },
    computed: {
        total_tagihan() {
            let number_string = this.tagihan.toString(),
                split = number_string.split(','),
                sisa = split[0].length % 3,
                rupiah = split[0].substring(0, sisa),
                ribuan = split[0].substring(sisa).match(/\d{3}/gi),
                separator = ''


            if (ribuan) {
                separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.')
            }

            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah
            return (rupiah ? 'Rp. ' + rupiah : '')
        },
        status_courier() {
            if (this.suspend == true) {
                return "Suspend";
            }
            return "Active"
        }
    },
    mounted() {
        this.refresh()
    }
}
</script>
<style scoped>
#home-card {
    background-color: #f36f21;
    width: 100%;
    left: 0;
    top: 0;
    border-top-left-radius: 10px 10px;
    border-top-right-radius: 10px 10px;
    position: absolute;
    padding: 20px;
    height: 105px;
    z-index: 1;
}

#total-invoice {
    z-index: 2;
    background-color: white;
    width: 93%;
    left: 50%;
    top: 67px;
    padding: 10px;
    min-height: 40px;
    position: absolute;
    border: 1px solid rgba(0, 0, 0, .1);
    font-size: 10px;
    color: #B2B2B2;
    transform: translate(-50%);
}

.nominal {
    padding-top: 5px;
    color: black;
    font-weight: bold;
    font-size: 2em;
}</style>